import _extends from "@babel/runtime/helpers/extends";
import _Cancel from "@mui/icons-material/Cancel";
import _Done from "@mui/icons-material/Done";
import { Chip as MuiChip } from '@mui/material';
import * as React from 'react';
import Icon from '../Icon';

var Chip = function Chip(_ref) {
  var dsOnDelete = _ref.dsOnDelete,
      e2e = _ref.e2e,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'default' : _ref$state,
      variant = _ref.variant,
      label = _ref.label,
      disabled = _ref.disabled,
      dismissible = _ref.dismissible,
      completable = _ref.completable,
      icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$uppercase = _ref.uppercase,
      uppercase = _ref$uppercase === void 0 ? true : _ref$uppercase,
      dsOnClick = _ref.dsOnClick;
  var ResolvedDeleteIcon = completable ? _Done : dismissible ? _Cancel : React.Fragment;
  var showDeleteIcon = completable || dismissible;
  return /*#__PURE__*/React.createElement(MuiChip, _extends({
    sx: {
      textTransform: uppercase ? 'uppercase' : 'none'
    }
  }, e2e && {
    'data-e2e': e2e
  }, {
    size: size,
    icon: icon && /*#__PURE__*/React.createElement(Icon, {
      fontSize: "small",
      body: icon
    }),
    label: label,
    disabled: disabled,
    variant: variant,
    onDelete: dismissible || completable ? dsOnDelete : undefined,
    deleteIcon: /*#__PURE__*/React.createElement(ResolvedDeleteIcon, showDeleteIcon && e2e && {
      'data-e2e': "".concat(e2e, "-complete-dismiss")
    }),
    onClick: dsOnClick,
    color: state
  }));
};

export default Chip;
//# sourceMappingURL=index.js.map